module.exports = __webpack_public_path__ + "img/us_logo@.0b43e70a.png";